function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, $hooks, Array, JSON, Object, String, billingAccountData, isOpen, isSupportWidgetMaximized, mp, showSupportWidget) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['help_menu_item'] = function(item) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("a", {
          "attrs": {
            href: item.href,
            target: item.target || undefined
          },
          "on": {
            click: item.handleItemClick || null
          },
          "class": {
            'help-menu-item': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'help-menu-item-icon': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
              "attrs": {
                icon: item.icon
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'help-menu-item-link-text': true
            },
          }, [__vjadeSafeCode(item.label)]));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          'hidden': $attr(`hidden`)
        }, {
          'widget-tray': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((showSupportWidget) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("support-widget-container", {
            "attrs": {
              'billing-account-data': JSON.stringify(billingAccountData),
              'events-plan-id': mp.report.globals.project_account_events_plan.id,
              'feature-gate-name': mp.report.globals.feature_gate_name,
              'people-plan-id': mp.report.globals.project_account_people_plan.id,
              'project-id': mp.report.globals.project_id,
              'user-age-in-days': mp.report.globals.user_age_days,
              'user-email': mp.report.globals.user_email,
              'user-id': mp.report.globals.user_id,
              'user-name': mp.report.globals.user_name,
            },
            "on": {
              'close': $helpers.closeSupportWidget,
            },
            "props": {
              'maximize': isSupportWidgetMaximized,
            },
          }));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(h("a", {
          "on": {
            click: $helpers.toggleHelpMenu,
          },
          "class": {
            'widget-toggle': true
          },
          "props": {
            id: 'help-button'
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": Object.assign({}, {
              'widget-hover-fill-expanded': isOpen
            }, {
              'widget-hover-fill': true
            }),
          }));
          __jade_nodes = __jade_nodes.concat(h("span", {
            "class": {
              'help-text': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("Help");;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'toggle-icon-wrapper': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
              "attrs": {
                icon: 'help'
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat((isOpen) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-drop-menu", {
              "hook": {
                remove: $hooks.delayedAttrRemove(`open`, false)
              },
              "attrs": {
                'open': true,
                'with-caret': true,
                'caret-pos-left': '88%',
                'inverted': false,
                'direction': 'up',
                'prevent-close-selectors': JSON.stringify([`#help-button`, `.widget-hover-fill`]),
              },
              "on": {
                change: $helpers.onMenuClose,
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'help-menu-header': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Help & Feedback");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'help-menu-items': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((function() {
                  var $$obj = ($helpers.helpMenuSections());
                  var $$eachNodes;
                  var $$iterated = false;
                  if (Array.isArray($$obj)) {
                    $$eachNodes = $$obj.reduce(function($$eachNodes, item, $index) {
                      $$iterated = true;
                      return $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(jade_mixins['help_menu_item'].call(this, item));;
                        return __jade_nodes
                      }).call(this));
                    }, []);
                  } else {
                    $$eachNodes = [];
                    for (var $$objKey in $$obj) {
                      (function() {
                        var $index = $$objKey;
                        if ($$obj.hasOwnProperty($index)) {
                          $$iterated = true;
                          var item = $$obj[$index];
                          $$eachNodes = $$eachNodes.concat((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(jade_mixins['help_menu_item'].call(this, item));;
                            return __jade_nodes
                          }).call(this));
                        }
                      })();
                    }
                  }

                  return $$eachNodes;
                })());;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "$hooks" in locals ? locals.$hooks : typeof $hooks !== "undefined" ? $hooks : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "billingAccountData" in locals ? locals.billingAccountData : typeof billingAccountData !== "undefined" ? billingAccountData : undefined, "isOpen" in locals ? locals.isOpen : typeof isOpen !== "undefined" ? isOpen : undefined, "isSupportWidgetMaximized" in locals ? locals.isSupportWidgetMaximized : typeof isSupportWidgetMaximized !== "undefined" ? isSupportWidgetMaximized : undefined, "mp" in locals ? locals.mp : typeof mp !== "undefined" ? mp : undefined, "showSupportWidget" in locals ? locals.showSupportWidget : typeof showSupportWidget !== "undefined" ? showSupportWidget : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;